const hasStorage = () => typeof window !== 'undefined' && window.localStorage;

export const languages = {
  Pt: {
    title_rooms: 'Salas',
    breadcrumb_home: 'Início',
    breadcrumb_processes: 'Processos',
    theme_label: 'Tema',
    language_label: 'Idioma',
    theme_light: 'Claro',
    theme_dark: 'Escuro',
    login_welcome: 'Bem-vindo',
    login_subtitle: 'Acesse sua conta para continuar.',
    email: 'E-mail',
    password: 'Senha',
    password_placeholder: 'Digite sua senha',
    enter: 'Entrar',
    login_hero_brand: 'ONTEST',
    login_hero_title: 'Fiscalização online com clareza e segurança.',
    login_hero_text: 'Monitore candidatos, salas e ocorrências em uma experiência moderna e direta.',
    exam_processes: 'Processos de prova',
    select_process_title: 'Escolha o processo que você vai fiscalizar',
    select_process_subtitle: 'Selecione a instituição ou processo seletivo para acessar o ambiente de autenticação fiscal.',
    access_supervision_room: 'Acessar sala de fiscalização',
    access: 'Acessar',
    no_process_available: 'Nenhum processo disponível no momento.',
    no_linked_process: 'Você não está vinculado a nenhum processo.',
    fiscal_panel: 'Painel do fiscal',
    fiscal_name: 'Nome do Fiscal',
    training_list: 'Lista de treinamentos',
    select_supervision: 'Selecione uma fiscalização',
    linked_processes_subtitle: 'Acompanhe os processos seletivos vinculados ao seu usuário fiscal.',
    process_singular: 'processo',
    process_plural: 'processos',
    filter_all: 'Todos',
    filter_active: 'Em andamento',
    filter_scheduled: 'Não iniciados',
    filter_closed: 'Encerrados',
    status_not_started: 'Não iniciado',
    status_closed: 'Encerrado',
    status_active: 'Em andamento',
    process_card_subtitle: 'Ambiente de fiscalização e acompanhamento dos candidatos',
    process_start: 'Início',
    process_end: 'Encerramento',
    no_process_found_status: 'Nenhum processo encontrado com o status "{status}".',
    total_online: 'Total online',
    online_this_room: 'Nesta sala',
    process_label: 'Processo',
    rooms_short: 'salas',
    candidates_short: 'candidatos',
    view_all_process_rooms: 'Ver salas de todos os processos',
    linked_process_rooms: 'Processos vinculados',
    candidates: 'Candidatos',
    notifications: 'Notificações',
    show_notifications: 'Mostrar notificações',
    hide_notifications: 'Esconder notificações',
    only_disconnected: 'Só desconectados',
    show_all: 'Mostrar todos',
    room_message: 'Mensagem para sala',
    general_announcement: 'Comunicado geral',
    general: 'Geral',
    chat: 'Chat',
    messages: 'Mensagens',
    back: 'Voltar',
    room: 'Sala',
    candidate_list: 'Lista de candidatos',
    candidate_list_title: 'Lista de Candidatos da Sala',
    candidates_in_queue: 'Candidatos na fila de apresentação',
    search_candidate: 'Buscar candidato...',
    no_candidate_found: 'Nenhum candidato encontrado.',
    online: 'Online',
    offline: 'Offline',
    fullscreen: 'Tela cheia',
    options: 'Opções',
    unread_messages: 'Mensagens não lidas',
    pending_request: 'Solicitação pendente',
    release_request: 'Pedido de liberação',
    pending_validation_room_single: 'Há 1 pedido de validação facial ou de documento nesta sala',
    pending_validation_room_multiple: 'Há {count} pedidos de validação facial ou de documento nesta sala',
    open_chat: 'Abrir chat',
    requests: 'Solicitações',
    webcam_screen: 'Webcam/tela',
    external_webcam: 'Webcam externa',
    view_camera: 'Visão da câmera',
    view_screen: 'Visão da tela',
    view_external_camera: 'Visão da câmera externa',
    candidate_ip: 'IP do candidato',
    external_camera_missing: 'Câmera externa desconectada',
    external_camera_missing_hint: 'Este processo exige câmera externa, mas o candidato online ainda não conectou o celular.',
    candidate_outside_screen: 'Candidato fora da tela',
    show_alerts: 'Ver alertas do candidato',
    hide_alerts: 'Ocultar alertas do candidato',
    report_action: 'Reportar ação',
    report_candidate_action: 'Reportar ação do candidato',
    left_exam: 'Saiu da prova',
    reconnect: 'Reconectar',
    present: 'Presente',
    absent: 'Ausente',
    presence: 'Presença',
    not_registered: 'Não registrado',
    mark_absent: 'Marcar como Ausente',
    mark_present: 'Marcar como Presente',
    screen_exits: 'Saídas',
    view_fullscreen: 'Ver em tela cheia',
    message_placeholder: 'Mensagem...',
    send: 'Enviar',
    close: 'Fechar',
    report_suspicious_action: 'Reportar Ação Suspeita',
    select_candidate: 'Selecione um candidato',
    name_label: 'Nome',
    action_label: 'Ação',
    action_placeholder: 'Ação a ser relatada',
    stage_terms: 'Na tela de termos',
    stage_terms_waiting: 'Preparando o acesso à avaliação',
    stage_waiting: 'Aguardando início',
    stage_rules: 'Aceitando regras',
    stage_evaluation: 'Em avaliação',
    stage_finished: 'Avaliação finalizada',
    stage_identity_validation: 'Validação de identidade',
    stage_document_validation: 'Validando documento',
    stage_face_validation: 'Validação facial',
    validation_identity: 'Validação de identidade',
    validation_biometric: 'Validação biométrica',
    validation_check_document: 'Conferir rosto e documento',
    validation_enter_exam_request: 'Solicitação para entrar na avaliação',
    face_photo: 'Foto do rosto',
    face_photo_helper: 'Imagem capturada pelo candidato antes do envio.',
    face_photo_alt: 'Foto do rosto enviada pelo candidato',
    document_photo: 'Foto do documento',
    document_photo_helper: 'Confira nome, foto e dados legíveis.',
    document_photo_alt: 'Foto do documento enviada pelo candidato',
    sent_composition: 'Composição enviada',
    sent_composition_helper: 'Fallback com rosto e documento juntos.',
    sent_composition_alt: 'Rosto do candidato ao lado do documento',
    candidate_label: 'Candidato',
    sent_photos_by_candidate: 'Fotos enviadas pelo candidato',
    sent_photos_helper: 'Confira a foto do rosto, a foto do documento e use a composição como apoio.',
    document_label: 'Documento',
    evidence_label: 'Evidências',
    capture_unavailable: 'A captura não está disponível. Negue a solicitação para o candidato refazer.',
    live_camera: 'Câmera ao vivo',
    live_camera_helper: 'Use a transmissão atual como apoio para a conferência.',
    disconnected: 'Desconectado...',
    switch_candidate_video: 'Alterar o vídeo do candidato para a webcam ou tela compartilhada',
    good_quality_video: 'Vídeo em boa qualidade',
    deny_and_request_new_capture: 'Negar e pedir nova captura',
    approve: 'Aprovar',
    camera_off: 'Câmera desligada',
    turn_camera_off: 'Desligar câmera',
    turn_camera_on: 'Ligar câmera',
    turn_microphone_off: 'Desligar microfone',
    turn_microphone_on: 'Ligar microfone',
    disconnect_screen_share: 'Desconectar compartilhamento',
    share_screen: 'Compartilhar tela',
    leave_call: 'Sair da chamada',
    hide_chat: 'Esconder chat',
    show_chat: 'Mostrar chat',
    hide_participants: 'Esconder participantes',
    show_participants: 'Mostrar participantes',
    evaluate_participant: 'Avaliar participante',
    proctor_information: 'Informações do Fiscal:',
    candidate_information: 'Informações do Candidato:',
    proctor_role: 'Fiscal',
    registration_number: 'Número de Inscrição',
    status_label: 'Status',
    enter_call: 'Entrar na Chamada',
    participants: 'Participantes',
    chat_with_candidate: 'Chat de {name}',
    chat_message_placeholder: 'Digite sua mensagem aqui...',
    screen_of: 'Tela de',
    camera_of: 'Câmera de',
    evaluation_information: 'Informações da avaliação',
    hide_information: 'Esconder informações',
    description_label: 'Descrição',
    start_label: 'Início',
    end_label: 'Fim',
    criteria_label: 'Critérios',
    criterion_code: 'Código do Critério',
    criterion_text: 'Texto do Critério',
    score_range: 'Range',
    score_label: 'Nota',
    final_score: 'Nota final',
    save_grades: 'Salvar notas',
    save_and_finish_evaluation: 'Salvar e encerrar avaliação',
    attention_title: 'Atenção',
    finish_evaluation_confirm: 'Sim, desejo finalizar',
    finish_evaluation_warning: 'Ao finalizar a avaliação do candidato, ele será retirado da vídeo chamada e não poderá mais acessá-la',
    unstable_connection: 'Sua conexão parece estar instável',
    candidate_called_attention: 'O candidato chamou sua atenção às {hour}',
    loading: 'Carregando...',
    loading_data: 'Carregando dados. Por favor, aguarde.',
    loading_environment: 'Aguarde enquanto preparamos seu ambiente.',
  },
  En: {
    title_rooms: 'Rooms',
    breadcrumb_home: 'Home',
    breadcrumb_processes: 'Processes',
    theme_label: 'Theme',
    language_label: 'Language',
    theme_light: 'Light',
    theme_dark: 'Dark',
    login_welcome: 'Welcome',
    login_subtitle: 'Access your account to continue.',
    email: 'E-mail',
    password: 'Password',
    password_placeholder: 'Enter your password',
    enter: 'Sign in',
    login_hero_brand: 'ONTEST',
    login_hero_title: 'Online proctoring with clarity and security.',
    login_hero_text: 'Monitor candidates, rooms, and incidents in a modern, direct experience.',
    exam_processes: 'Exam processes',
    select_process_title: 'Choose the process you will proctor',
    select_process_subtitle: 'Select the institution or selection process to access the proctor authentication environment.',
    access_supervision_room: 'Access proctoring room',
    access: 'Access',
    no_process_available: 'No process available at the moment.',
    no_linked_process: 'You are not linked to any process.',
    fiscal_panel: 'Proctor panel',
    fiscal_name: 'Proctor name',
    training_list: 'Training list',
    select_supervision: 'Select a proctoring session',
    linked_processes_subtitle: 'Track the selection processes linked to your proctor user.',
    process_singular: 'process',
    process_plural: 'processes',
    filter_all: 'All',
    filter_active: 'In progress',
    filter_scheduled: 'Not started',
    filter_closed: 'Closed',
    status_not_started: 'Not started',
    status_closed: 'Closed',
    status_active: 'In progress',
    process_card_subtitle: 'Proctoring and candidate monitoring environment',
    process_start: 'Start',
    process_end: 'End',
    no_process_found_status: 'No process found with status "{status}".',
    total_online: 'Total online',
    online_this_room: 'In this room',
    process_label: 'Process',
    rooms_short: 'rooms',
    candidates_short: 'candidates',
    view_all_process_rooms: 'View rooms from all processes',
    linked_process_rooms: 'Linked processes',
    candidates: 'Candidates',
    notifications: 'Notifications',
    show_notifications: 'Show notifications',
    hide_notifications: 'Hide notifications',
    only_disconnected: 'Only disconnected',
    show_all: 'Show all',
    room_message: 'Room message',
    general_announcement: 'General announcement',
    general: 'General',
    chat: 'Chat',
    messages: 'Messages',
    back: 'Back',
    room: 'Room',
    candidate_list: 'Candidate list',
    candidate_list_title: 'Candidate List for Room',
    candidates_in_queue: 'Candidates in presentation queue',
    search_candidate: 'Search candidate...',
    no_candidate_found: 'No candidate found.',
    online: 'Online',
    offline: 'Offline',
    fullscreen: 'Fullscreen',
    options: 'Options',
    unread_messages: 'Unread messages',
    pending_request: 'Pending request',
    release_request: 'Release request',
    pending_validation_room_single: 'There is 1 face or document validation request in this room',
    pending_validation_room_multiple: 'There are {count} face or document validation requests in this room',
    open_chat: 'Open chat',
    requests: 'Requests',
    webcam_screen: 'Webcam/screen',
    external_webcam: 'External webcam',
    view_camera: 'Camera view',
    view_screen: 'Screen view',
    view_external_camera: 'External camera view',
    candidate_ip: 'Candidate IP',
    external_camera_missing: 'External camera disconnected',
    external_camera_missing_hint: 'This process requires an external camera, but the online candidate has not connected the phone yet.',
    candidate_outside_screen: 'Candidate outside the screen',
    show_alerts: 'View candidate alerts',
    hide_alerts: 'Hide candidate alerts',
    report_action: 'Report action',
    report_candidate_action: 'Report candidate action',
    left_exam: 'Left the exam',
    reconnect: 'Reconnect',
    present: 'Present',
    absent: 'Absent',
    presence: 'Presence',
    not_registered: 'Not registered',
    mark_absent: 'Mark as absent',
    mark_present: 'Mark as present',
    screen_exits: 'Screen exits',
    view_fullscreen: 'View fullscreen',
    message_placeholder: 'Message...',
    send: 'Send',
    close: 'Close',
    report_suspicious_action: 'Report Suspicious Action',
    select_candidate: 'Select a candidate',
    name_label: 'Name',
    action_label: 'Action',
    action_placeholder: 'Action to be reported',
    stage_terms: 'On terms screen',
    stage_terms_waiting: 'Preparing exam access',
    stage_waiting: 'Waiting to start',
    stage_rules: 'Accepting rules',
    stage_evaluation: 'Taking exam',
    stage_finished: 'Exam finished',
    stage_identity_validation: 'Identity validation',
    stage_document_validation: 'Validating document',
    stage_face_validation: 'Face validation',
    validation_identity: 'Identity validation',
    validation_biometric: 'Biometric validation',
    validation_check_document: 'Check face and document',
    validation_enter_exam_request: 'Request to enter the exam',
    face_photo: 'Face photo',
    face_photo_helper: 'Image captured by the candidate before submission.',
    face_photo_alt: 'Face photo submitted by the candidate',
    document_photo: 'Document photo',
    document_photo_helper: 'Check the name, photo, and readable details.',
    document_photo_alt: 'Document photo submitted by the candidate',
    sent_composition: 'Submitted composition',
    sent_composition_helper: 'Fallback with face and document together.',
    sent_composition_alt: 'Candidate face next to the document',
    candidate_label: 'Candidate',
    sent_photos_by_candidate: 'Photos submitted by the candidate',
    sent_photos_helper: 'Check the face photo, the document photo, and use the composition as support.',
    document_label: 'Document',
    evidence_label: 'Evidence',
    capture_unavailable: 'The capture is not available. Deny the request so the candidate can redo it.',
    live_camera: 'Live camera',
    live_camera_helper: 'Use the current stream as support for the check.',
    disconnected: 'Disconnected...',
    switch_candidate_video: 'Switch the candidate video between webcam and shared screen',
    good_quality_video: 'Good quality video',
    deny_and_request_new_capture: 'Deny and request a new capture',
    approve: 'Approve',
    camera_off: 'Camera off',
    turn_camera_off: 'Turn camera off',
    turn_camera_on: 'Turn camera on',
    turn_microphone_off: 'Turn microphone off',
    turn_microphone_on: 'Turn microphone on',
    disconnect_screen_share: 'Disconnect sharing',
    share_screen: 'Share screen',
    leave_call: 'Leave call',
    hide_chat: 'Hide chat',
    show_chat: 'Show chat',
    hide_participants: 'Hide participants',
    show_participants: 'Show participants',
    evaluate_participant: 'Evaluate participant',
    proctor_information: 'Proctor information:',
    candidate_information: 'Candidate information:',
    proctor_role: 'Proctor',
    registration_number: 'Registration number',
    status_label: 'Status',
    enter_call: 'Join Call',
    participants: 'Participants',
    chat_with_candidate: 'Chat with {name}',
    chat_message_placeholder: 'Type your message here...',
    screen_of: 'Screen of',
    camera_of: 'Camera of',
    evaluation_information: 'Evaluation information',
    hide_information: 'Hide information',
    description_label: 'Description',
    start_label: 'Start',
    end_label: 'End',
    criteria_label: 'Criteria',
    criterion_code: 'Criterion code',
    criterion_text: 'Criterion text',
    score_range: 'Range',
    score_label: 'Score',
    final_score: 'Final score',
    save_grades: 'Save grades',
    save_and_finish_evaluation: 'Save and finish evaluation',
    attention_title: 'Attention',
    finish_evaluation_confirm: 'Yes, finish',
    finish_evaluation_warning: 'When you finish the candidate evaluation, the candidate will be removed from the video call and will not be able to access it again.',
    unstable_connection: 'Your connection seems unstable',
    candidate_called_attention: 'The candidate called your attention at {hour}',
    loading: 'Loading...',
    loading_data: 'Loading data. Please wait.',
    loading_environment: 'Please wait while we prepare your environment.',
  },
  Es: {
    title_rooms: 'Salas',
    breadcrumb_home: 'Inicio',
    breadcrumb_processes: 'Procesos',
    theme_label: 'Tema',
    language_label: 'Idioma',
    theme_light: 'Claro',
    theme_dark: 'Oscuro',
    login_welcome: 'Bienvenido',
    login_subtitle: 'Accede a tu cuenta para continuar.',
    email: 'E-mail',
    password: 'Contraseña',
    password_placeholder: 'Ingresa tu contraseña',
    enter: 'Entrar',
    login_hero_brand: 'ONTEST',
    login_hero_title: 'Fiscalización en línea con claridad y seguridad.',
    login_hero_text: 'Monitorea candidatos, salas e incidentes en una experiencia moderna y directa.',
    exam_processes: 'Procesos de prueba',
    select_process_title: 'Elige el proceso que vas a fiscalizar',
    select_process_subtitle: 'Selecciona la institución o proceso selectivo para acceder al ambiente de autenticación fiscal.',
    access_supervision_room: 'Acceder a la sala de fiscalización',
    access: 'Acceder',
    no_process_available: 'No hay procesos disponibles en este momento.',
    no_linked_process: 'No estás vinculado a ningún proceso.',
    fiscal_panel: 'Panel del fiscal',
    fiscal_name: 'Nombre del fiscal',
    training_list: 'Lista de entrenamientos',
    select_supervision: 'Selecciona una fiscalización',
    linked_processes_subtitle: 'Acompaña los procesos selectivos vinculados a tu usuario fiscal.',
    process_singular: 'proceso',
    process_plural: 'procesos',
    filter_all: 'Todos',
    filter_active: 'En curso',
    filter_scheduled: 'No iniciados',
    filter_closed: 'Cerrados',
    status_not_started: 'No iniciado',
    status_closed: 'Cerrado',
    status_active: 'En curso',
    process_card_subtitle: 'Ambiente de fiscalización y seguimiento de candidatos',
    process_start: 'Inicio',
    process_end: 'Cierre',
    no_process_found_status: 'No se encontró ningún proceso con el estado "{status}".',
    total_online: 'Total en línea',
    online_this_room: 'En esta sala',
    process_label: 'Proceso',
    rooms_short: 'salas',
    candidates_short: 'candidatos',
    view_all_process_rooms: 'Ver salas de todos los procesos',
    linked_process_rooms: 'Procesos vinculados',
    candidates: 'Candidatos',
    notifications: 'Notificaciones',
    show_notifications: 'Mostrar notificaciones',
    hide_notifications: 'Ocultar notificaciones',
    only_disconnected: 'Solo desconectados',
    show_all: 'Mostrar todos',
    room_message: 'Mensaje para sala',
    general_announcement: 'Comunicado general',
    general: 'General',
    chat: 'Chat',
    messages: 'Mensajes',
    back: 'Volver',
    room: 'Sala',
    candidate_list: 'Lista de candidatos',
    candidate_list_title: 'Lista de Candidatos de la Sala',
    candidates_in_queue: 'Candidatos en la fila de presentación',
    search_candidate: 'Buscar candidato...',
    no_candidate_found: 'No se encontró ningún candidato.',
    online: 'En línea',
    offline: 'Desconectado',
    fullscreen: 'Pantalla completa',
    options: 'Opciones',
    unread_messages: 'Mensajes no leídos',
    pending_request: 'Solicitud pendiente',
    release_request: 'Solicitud de liberación',
    pending_validation_room_single: 'Hay 1 solicitud de validación facial o de documento en esta sala',
    pending_validation_room_multiple: 'Hay {count} solicitudes de validación facial o de documento en esta sala',
    open_chat: 'Abrir chat',
    requests: 'Solicitudes',
    webcam_screen: 'Webcam/pantalla',
    external_webcam: 'Webcam externa',
    view_camera: 'Vista de cámara',
    view_screen: 'Vista de pantalla',
    view_external_camera: 'Vista de cámara externa',
    candidate_ip: 'IP del candidato',
    external_camera_missing: 'Cámara externa desconectada',
    external_camera_missing_hint: 'Este proceso exige cámara externa, pero el candidato en línea aún no conectó el celular.',
    candidate_outside_screen: 'Candidato fuera de la pantalla',
    show_alerts: 'Ver alertas del candidato',
    hide_alerts: 'Ocultar alertas del candidato',
    report_action: 'Reportar acción',
    report_candidate_action: 'Reportar acción del candidato',
    left_exam: 'Salió de la prueba',
    reconnect: 'Reconectar',
    present: 'Presente',
    absent: 'Ausente',
    presence: 'Presencia',
    not_registered: 'No registrado',
    mark_absent: 'Marcar como ausente',
    mark_present: 'Marcar como presente',
    screen_exits: 'Salidas de pantalla',
    view_fullscreen: 'Ver en pantalla completa',
    message_placeholder: 'Mensaje...',
    send: 'Enviar',
    close: 'Cerrar',
    report_suspicious_action: 'Reportar Acción Sospechosa',
    select_candidate: 'Selecciona un candidato',
    name_label: 'Nombre',
    action_label: 'Acción',
    action_placeholder: 'Acción a reportar',
    stage_terms: 'En la pantalla de términos',
    stage_terms_waiting: 'Preparando el acceso a la evaluación',
    stage_waiting: 'Esperando el inicio',
    stage_rules: 'Aceptando reglas',
    stage_evaluation: 'En evaluación',
    stage_finished: 'Evaluación finalizada',
    stage_identity_validation: 'Validación de identidad',
    stage_document_validation: 'Validando documento',
    stage_face_validation: 'Validación facial',
    validation_identity: 'Validación de identidad',
    validation_biometric: 'Validación biométrica',
    validation_check_document: 'Revisar rostro y documento',
    validation_enter_exam_request: 'Solicitud para entrar a la evaluación',
    face_photo: 'Foto del rostro',
    face_photo_helper: 'Imagen capturada por el candidato antes del envío.',
    face_photo_alt: 'Foto del rostro enviada por el candidato',
    document_photo: 'Foto del documento',
    document_photo_helper: 'Verifica nombre, foto y datos legibles.',
    document_photo_alt: 'Foto del documento enviada por el candidato',
    sent_composition: 'Composición enviada',
    sent_composition_helper: 'Respaldo con rostro y documento juntos.',
    sent_composition_alt: 'Rostro del candidato junto al documento',
    candidate_label: 'Candidato',
    sent_photos_by_candidate: 'Fotos enviadas por el candidato',
    sent_photos_helper: 'Verifica la foto del rostro, la foto del documento y usa la composición como apoyo.',
    document_label: 'Documento',
    evidence_label: 'Evidencias',
    capture_unavailable: 'La captura no está disponible. Niega la solicitud para que el candidato la rehaga.',
    live_camera: 'Cámara en vivo',
    live_camera_helper: 'Usa la transmisión actual como apoyo para la revisión.',
    disconnected: 'Desconectado...',
    switch_candidate_video: 'Cambiar el video del candidato entre webcam y pantalla compartida',
    good_quality_video: 'Video en buena calidad',
    deny_and_request_new_capture: 'Negar y pedir nueva captura',
    approve: 'Aprobar',
    camera_off: 'Cámara apagada',
    turn_camera_off: 'Apagar cámara',
    turn_camera_on: 'Encender cámara',
    turn_microphone_off: 'Apagar micrófono',
    turn_microphone_on: 'Encender micrófono',
    disconnect_screen_share: 'Desconectar pantalla compartida',
    share_screen: 'Compartir pantalla',
    leave_call: 'Salir de la llamada',
    hide_chat: 'Ocultar chat',
    show_chat: 'Mostrar chat',
    hide_participants: 'Ocultar participantes',
    show_participants: 'Mostrar participantes',
    evaluate_participant: 'Evaluar participante',
    proctor_information: 'Información del fiscal:',
    candidate_information: 'Información del candidato:',
    proctor_role: 'Fiscal',
    registration_number: 'Número de inscripción',
    status_label: 'Estado',
    enter_call: 'Entrar a la llamada',
    participants: 'Participantes',
    chat_with_candidate: 'Chat de {name}',
    chat_message_placeholder: 'Escribe tu mensaje aquí...',
    screen_of: 'Pantalla de',
    camera_of: 'Cámara de',
    evaluation_information: 'Información de la evaluación',
    hide_information: 'Ocultar información',
    description_label: 'Descripción',
    start_label: 'Inicio',
    end_label: 'Fin',
    criteria_label: 'Criterios',
    criterion_code: 'Código del criterio',
    criterion_text: 'Texto del criterio',
    score_range: 'Rango',
    score_label: 'Nota',
    final_score: 'Nota final',
    save_grades: 'Guardar notas',
    save_and_finish_evaluation: 'Guardar y cerrar evaluación',
    attention_title: 'Atención',
    finish_evaluation_confirm: 'Sí, deseo finalizar',
    finish_evaluation_warning: 'Al finalizar la evaluación del candidato, será retirado de la videollamada y no podrá acceder de nuevo.',
    unstable_connection: 'Tu conexión parece inestable',
    candidate_called_attention: 'El candidato llamó tu atención a las {hour}',
    loading: 'Cargando...',
    loading_data: 'Cargando datos. Por favor, espera.',
    loading_environment: 'Espera mientras preparamos tu ambiente.',
  },
};

export const languageOptions = [
  { value: 'Pt', label: 'Português' },
  { value: 'En', label: 'English' },
  { value: 'Es', label: 'Español' },
];

export function getSelectedLanguage() {
  if (!hasStorage()) return 'Pt';
  const selectedLanguage = window.localStorage.getItem('fiscal_language') || 'Pt';
  return languages[selectedLanguage] ? selectedLanguage : 'Pt';
}

export function setSelectedLanguage(language) {
  const selectedLanguage = languages[language] ? language : 'Pt';
  if (hasStorage()) {
    window.localStorage.setItem('fiscal_language', selectedLanguage);
  }
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent('fiscal_language_change', { detail: selectedLanguage }));
  }
  return selectedLanguage;
}

export function getLanguageTexts(language) {
  return languages[language] || languages.Pt;
}
